import { MenuItem } from '@mui/material';
import { Menu } from '@mui/material';
import { ArrowDropDown, FileDownload, UploadFile } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Box } from '@mui/material';
import React, { useState } from 'react'
import { useNotification, useTranslate } from '@refinedev/core';

export const ImportButton = ({ inputProps, csvHeaders, disabled, type }: { inputProps: any, csvHeaders: string[], disabled?: boolean, type: "company" | "product" | "contact" }) => {
    
    const t = useTranslate();
    const { open } = useNotification();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
    const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleMenuClose = () => {
      setAnchorEl(null);
    };
    
    const handleDownloadTemplate = () => {
        // Create a sample CSV template for company import
        const csvContent = csvHeaders.join(",");
        
        // Create a Blob containing the CSV data
        const blob = new Blob([csvContent], { type: 'text/csv' });
        
        // Create a temporary download link
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${type}_import_template.csv`;
        
        // Append to body, click and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Release the object URL
        URL.revokeObjectURL(url);
        
        open?.({
          message: "Template Downloaded",
          description: `${type} import template has been downloaded`,
          type: "success",
        });
        handleMenuClose();
      };
    
    return (
        <Box sx={{ display: 'flex' }}>
            <Button
                color="primary"
                variant="outlined"
                startIcon={<UploadFile />}
                endIcon={<ArrowDropDown />}
                onClick={handleMenuClick}
                sx={{ height: "40px" }}
                disabled={disabled}
            >
                {t("buttons.csv-import")}
            </Button>
            <Menu
                id="import-menu"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={() => {
                    const fileInput = document.createElement('input');
                    fileInput.type = 'file';
                    fileInput.accept = '.csv';
                    fileInput.multiple = false;

                    // Apply all the inputProps attributes to our file input
                    Object.entries(inputProps).forEach(([key, value]) => {
                        if (key === 'ref') {
                            // Skip ref handling as it's meant for React components
                            return;
                        }
                        // @ts-ignore
                        fileInput[key] = value;
                    });

                    // Add change event listener to handle selected file
                    fileInput.addEventListener('change', (event) => {
                        // If inputProps.onChange exists, call it with the event
                        if (inputProps.onChange) {
                            // Type assertion with unknown as intermediate step for safer casting
                            const changeEvent = event as unknown as React.ChangeEvent<HTMLInputElement>;
                            inputProps.onChange(changeEvent);
                        }
                    });

                    fileInput.click();
                    handleMenuClose();
                }}>
                    <UploadFile fontSize="small" sx={{ mr: 1 }} />
                    Import Data
                </MenuItem>
                <MenuItem onClick={handleDownloadTemplate}>
                    <FileDownload fontSize="small" sx={{ mr: 1 }} />
                    Download Template
                </MenuItem>
            </Menu>
        </Box>
    )
}